import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {isEmptyVariable, isEmptyArray} from '../../../common/Global/commonFunctions';
import {TableRadioButton,DialogSaveButton,TableCheckBox, FilterCheckBox} from '../../../common/Global/globalStyles.style';
import {Modal} from 'react-bootstrap';
import * as TemplateConstants from "../../../common/Global/templateConstants";
import EditTaskDescriptionDialog from "./editTaskDescriptionDialog";
import AlertDialog from '../../../common/AlertDialog';

class SelectDropdownValues extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            dropdownValues:[],
            value_NR:"N",
            showDescriptionDialog:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            isRiskImpact:false
        }
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) 
        && this.props.showSelectDropdownDialog) {
            let fieldObj = JSON.parse(JSON.stringify(this.props.fieldObj));
            let dropdownValues = [...fieldObj.dropdownValues];

            if(fieldObj.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                fieldObj.fieldType === TemplateConstants.FIELD_TYPE_ISO){
                //now check for field Value
                if(!isEmptyVariable(fieldObj.fieldValue)){
                    let dropdownValuesNew = [];
                    dropdownValues.forEach(item=>{
                        if(item.value === fieldObj.fieldValue){
                            item.isChecked = "Y";
                        }else{
                            item.isChecked = "N";
                        }
                        dropdownValuesNew.push(item)
                    })
                    dropdownValues = dropdownValuesNew;
                }
            }else if(fieldObj.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                fieldObj.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI
            ){
                if(!isEmptyArray(fieldObj.fieldValue)){
                    let dropdownValuesNew = [];
                    dropdownValues.forEach(dropdownItem=>{
                        let flag = fieldObj.fieldValue.some(item=>item === dropdownItem.value)
                        let flagOther = fieldObj.fieldValue.some(item=>item.includes('Other') && item.split(":-:")[0] === dropdownItem.value)
                        if(flagOther){
                            dropdownItem.description = fieldObj.fieldValue.find(item=>item.split(":-:")[0] === dropdownItem.value).split(":-:")[1]
                        }
                        if(flag || flagOther){
                            dropdownItem.isChecked = "Y";
                        }else{
                            dropdownItem.isChecked = "N";
                        }
                        dropdownValuesNew.push(dropdownItem)
                    })
                    dropdownValues = dropdownValuesNew;
                }
            }
            if(this.props.assignmentTaskAllowEdit == "N" && fieldObj.fieldName == "Risk/Impact"){
                dropdownValues = dropdownValues.filter(item => item.isChecked === "Y")
            }
            this.setState({
                dropdownValues:dropdownValues,
                value_NR:fieldObj.fieldValueNR === "Y"?"Y":"N",
                isRiskImpact:fieldObj.fieldName == "Risk/Impact"?true:false,
            })
        }
    }

    handleSelectionRadio = (e) => {
		let dropdownIndex = e.target.name;

        let newDropdownValues = this.state.dropdownValues.map((item,index)=>{
            if(index+"" === dropdownIndex+""){
                item.isChecked = "Y"
            }else{
                item.isChecked = "N"
            }

            return item;
        })
        this.setState({
            dropdownValues:newDropdownValues
        })

    }

    handleSelectionCheckbox = (e) => {
        let isChecked = e.target.checked;
		let dropdownIndex = e.target.name;

        let newDropdownValues = this.state.dropdownValues.map((item,index)=>{
            if(index+"" === dropdownIndex+""){
                item.isChecked = isChecked?"Y":"N"
            }
            return item;
        })
        
        this.setState({
            dropdownValues:newDropdownValues
        })
    }

    returnSelectedValues = () => {
        let selectedValues = [];
        let error = false;
        this.state.dropdownValues.forEach(item=>{
            if(item.isChecked === "Y"){
                if(item.value == "Other"){
                    if(!isEmptyVariable(item.description)){
                        selectedValues.push(`Other:-:`+item.description) 
                    }else{
                        error = true;
                    }
                }else{
                    selectedValues.push(item.value) 
                }
            }
        })

        
        // let errorMsg = "";
        if(isEmptyArray(selectedValues) && this.state.value_NR !== "Y"){
            error = true;
            // errorMsg = "Please select the value";
        }
        
        if(error){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please enter the risk for the selected 'other' risk."
            })
        }else{
            let returnArr =  {
                fieldType:this.props.fieldObj.fieldType,
                selectedValues:selectedValues,
            }
            //TODO
            //Check for empty selection
            this.props.dialogSelectedValues(returnArr,this.props.taskId, this.props.fieldArrIndex,this.props.selectedProcessId, this.props.selectedFunctionId,this.state.value_NR);
        }
    }

    handleCheck = (e) =>{
        let isChecked = e.target.checked;

        let newDropdownValues = this.state.dropdownValues.map((item,index)=>{
            item.isChecked = "N";
            return item;
        })

        this.setState({
            value_NR:isChecked?"Y":"N",
            dropdownValues:newDropdownValues
        })
    }

    // Description column shows when configured to (alone or with a separator). Older assignments/fields
    // saved before these keys existed have neither key at all - default those back to always showing it.
    isDescriptionColumnVisible = () => {
        let fieldObj = this.props.fieldObj;
        if(isEmptyVariable(fieldObj?.showOnlyDescription) && isEmptyVariable(fieldObj?.showDescriptionSeparator)){
            return true;
        }
        return fieldObj?.showOnlyDescription === "Y" || fieldObj?.showDescriptionSeparator === "Y";
    }

    // Returns the configured separator for a row, only when showDescriptionSeparator is enabled and a description exists.
    getSeparatorDisplay = (item) => {
        if(isEmptyVariable(item.description) || this.props.fieldObj?.showDescriptionSeparator !== "Y"){
            return "";
        }
        return this.props.fieldObj?.descriptionSeparator || "";
    }

    handleDescription = (item) => {
        this.setState({
            showDescriptionDialog:true,
            selectedItem:item,
            oldSelectedItem:item
        })
    }

    handleDescriptionDialogClose = (description, reloadFlag) => {
        let selectedItem = this.state.selectedItem;
        if(selectedItem.value === "Other" && 
            (isEmptyVariable(selectedItem.description) ||
            (!isEmptyVariable(description) && this.state.oldSelectedItem.description !== description)) ||
            (isEmptyVariable(description) && reloadFlag == true)
        ){
            selectedItem.description = description;
        }

        this.setState({
            showDescriptionDialog:false,
            selectedItem:selectedItem,
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    render(){
        return(
            <section>
                <Modal className="task-select-dept-dialog custom-dialog"
                    show={this.props.showSelectDropdownDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{this.props.fieldObj?.fieldName}{this.props.fieldObj?.isMandatorySelected === "Y"?"*":""}</h5>
                        <button 
                            onClick={this.props.handleSelectDropdownDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            {
                                !isEmptyArray(this.state.dropdownValues) && 
                                this.props.fieldObj?.isNotReqSelected === "Y" &&
                                <div className='exec-not-req-layout'>
                                    <FilterCheckBox themeSettings={this.props.themeSettings}
                                    style={{marginLeft:0}}>
                                        <input 
                                            type="checkbox"
                                            name="value_NR"
                                            id="value_NR"
                                            onChange={this.handleCheck}
                                            checked={this.state.value_NR === "Y"?true:false}
                                            disabled={this.props.assignmentTaskAllowEdit === "Y" ? false : true}
                                        />
                                        <label for="value_NR">Not Applicable</label>
                                    </FilterCheckBox>
                                </div>
                            }
                            <div style={{position:"relative"}}>
                                {
                                    !isEmptyArray(this.state.dropdownValues) && 
                                    <div className="common-tab-bg">
                                        <div className="common-table" style={{width:"100%",border:"1px solid #e5e5e5"}}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" width={"8%"}></th>
                                                        <th className="text-center" width={"5%"}>No</th>
                                                        <th>Value</th>
                                                        {
                                                            this.props.fieldObj?.showDescriptionSeparator === "Y" &&
                                                            <th></th>
                                                        }
                                                        {
                                                            this.isDescriptionColumnVisible() &&
                                                            <th>Description</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    !isEmptyArray(this.state.dropdownValues) && 
                                                    this.state.dropdownValues.map((item,idx) => {

                                                        return <tr>
                                                            <td>
                                                                {
                                                                    (this.props.fieldObj?.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                                                                    this.props.fieldObj?.fieldType === TemplateConstants.FIELD_TYPE_ISO) &&
                                                                    <TableRadioButton
                                                                        themeSettings={this.props.themeSettings}>
                                                                        <input 
                                                                            type="checkbox"
                                                                            name={idx}
                                                                            id={idx}
                                                                            onChange={this.handleSelectionRadio}
                                                                            checked={item.isChecked === "Y"}
                                                                            disabled={this.props.viewOnly === "Y" && this.props.assignmentTaskAllowEdit === "N" ?true:false}
                                                                        />
                                                                        <label for={idx} 
                                                                        style={{marginLeft:6}}></label>
                                                                    </TableRadioButton>
                                                                }
                                                                {
                                                                    (this.props.fieldObj?.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                                                                    this.props.fieldObj?.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI) &&
                                                                    <TableCheckBox themeSettings={this.props.themeSettings}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={idx}
                                                                        id={idx}
                                                                        onChange={this.handleSelectionCheckbox}
                                                                        checked={item.isChecked === "Y"}
                                                                        disabled={this.props.viewOnly === "Y"?true:(this.props.assignmentTaskAllowEdit === "N" ?true:false)}
                                                                    />
                                                                    <label for={idx} style={{ marginLeft: 6 }}></label>
                                                                </TableCheckBox>
                                                                }
                                                            </td>
                                                            <td className="text-center">{(idx+1)}</td>
                                                            <td>{item.value}</td>
                                                            {
                                                                this.props.fieldObj?.showDescriptionSeparator === "Y" &&
                                                                <td>{this.getSeparatorDisplay(item)}</td>
                                                            }
                                                            {
                                                                this.isDescriptionColumnVisible() &&
                                                                <td onClick={item.value == "Other" && this.props.assignmentTaskAllowEdit !== "N" && this.props.isEditDescription ? this.handleDescription.bind(this,item): ""}>{isEmptyVariable(item.description)?"":item.description}</td>
                                                            }
                                                        </tr>
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }
                                <div className="overlay-nr" style={{display:this.state.value_NR === "Y"?"block":"none"}}>
                                </div>
                            </div>
                            {
                                isEmptyArray(this.state.dropdownValues) && !this.state.isRiskImpact &&
                                <div class="no-items-layout">
                                    <div class="no-items-card">
                                        <h6>{Constants.EMPTY_SEARCH_WARNING}</h6>
                                    </div>
                                </div>
                            }
                            {
                                isEmptyArray(this.state.dropdownValues) && this.state.isRiskImpact &&
                                <div class="no-items-layout">
                                    <div class="no-items-card">
                                        <h6>{Constants.NO_RISK_FOR_TASK_WARNING}</h6>
                                    </div>
                                </div>
                            }
                            {/* {
                                !isEmptyVariable(this.state.selectErr) &&
                                <span className="cm-error">{this.state.selectErr}</span>
                            } */}
                            <div className="modal-close-save m-t-15">
                                <div className="close-save-col">
                                    <button onClick={this.props.handleSelectDropdownDialogClose} type="button" 
                                    className="modal-close m-b-0">Cancel</button>
                                    
                                    {
                                        this.props.assignmentTaskAllowEdit !== "N" &&
                                        <DialogSaveButton  
                                        themeSettings={this.props.themeSettings} 
                                        onClick={this.props.viewOnly === "Y"?this.props.handleSelectDropdownDialogClose:this.returnSelectedValues} 
                                        type="button" 
                                        disabled={this.props.showLoader}
                                        className="modal-save m-b-0">
                                            {this.props.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                        </DialogSaveButton>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <EditTaskDescriptionDialog
                    showDescriptionDialog={this.state.showDescriptionDialog}
                    handleDescriptionDialogClose={this.handleDescriptionDialogClose}
                    themeSettings={this.props.themeSettings}
                    item={this.state.selectedItem}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </section>
        )
    }

}

export default SelectDropdownValues;